<template>
    <v-card flat class="flex-grow-1 d-flex flex-column" style="min-height: 0; position: relative;">
        <!-- Scroll controls at top -->
        <div v-if="showScrollToTop" class="d-flex justify-end pa-2"
            style="position: absolute; top: 0; right: 0; z-index: 3;">
            <v-btn fab small color="primary" @click="scrollToTop" class="mr-1">
                <v-icon>mdi-arrow-up</v-icon>
            </v-btn>
        </div>

        <!-- Empty state -->
        <div v-if="timelineItems.length === 0" class="pa-4 text-center text--secondary">
            <v-icon large>mdi-message-outline</v-icon>
            <div class="mt-2">Brak wiadomości</div>
        </div>

        <!-- Timeline container -->
        <div v-else ref="timelineContainer" class="px-3" style="overflow-y: auto; min-height: 0; flex-grow: 1;">
            <component v-for="item in timelineItems" :key="item.id" :is="getTimelineComponent(item)" :item="item"
                :read-only="readOnly"
                :enable-long-press="enableLongPress"
                @edit="$emit('edit', $event)"
                @delete="$emit('delete', $event)"
                @edit-travel-time="$emit('edit-travel-time', $event)"
                @edit-on-site-time="$emit('edit-on-site-time', $event)"
                @file-open="$emit('file-open', $event)"
                @action="$emit('action', $event)" class="mb-1" />
        </div>
    </v-card>
</template>

<script>
import { getTimelineComponent } from '@/components/timeline/index'

export default {
    name: "EventTimelineScrollContainer",

    props: {
        timelineItems: {
            type: Array,
            required: true
        },
        task: {
            type: Object,
            default: null
        },
        readOnly: {
            type: Boolean,
            default: false
        },
        enableLongPress: {
            type: Boolean,
            default: true
        }
    },

    data() {
        return {
            showScrollToTop: false
        }
    },

    mounted() {
        this.$nextTick(() => {
            this.scrollToBottom()
        })

        this.$nextTick(() => {
            this.addScrollListener()
        })
    },

    beforeDestroy() {
        this.removeScrollListener()
    },

        watch: {
        timelineItems: {
            handler() {
                this.$nextTick(() => {
                    this.scrollToBottom()
                    this.ensureScrollListener()
                })
            },
            deep: true
        }
    },    methods: {
        getTimelineComponent,

        scrollToBottom() {
            if (this.$refs.timelineContainer && this.timelineItems.length > 0) {
                const container = this.$refs.timelineContainer
                container.scrollTop = container.scrollHeight
            }
        },

        scrollToTop() {
            if (this.$refs.timelineContainer) {
                const container = this.$refs.timelineContainer
                container.scrollTop = 0
            }
        },

        addScrollListener() {
            if (this.$refs.timelineContainer) {
                this.$refs.timelineContainer.addEventListener('scroll', this.onScroll, { passive: true })
            }
        },

        removeScrollListener() {
            if (this.$refs.timelineContainer) {
                this.$refs.timelineContainer.removeEventListener('scroll', this.onScroll)
            }
        },

        ensureScrollListener() {
            // Ensure scroll listener is attached when DOM changes
            if (this.$refs.timelineContainer && this.timelineItems.length > 0) {
                this.removeScrollListener()
                this.addScrollListener()
            }
        },

        onScroll() {
            const container = this.$refs.timelineContainer
            if (!container) {
                return
            }

            const scrollTop = container.scrollTop
            const hasEnoughItems = this.timelineItems.length > 3
            const isScrolledDownFromTop = scrollTop > 100
            const shouldShow = isScrolledDownFromTop && hasEnoughItems

            if (this.showScrollToTop !== shouldShow) {
                this.showScrollToTop = shouldShow
            }
        },

        // External methods for parent component
        scrollToBottomExternal() {
            this.scrollToBottom()
        },

        ensureScrollListenerExternal() {
            this.ensureScrollListener()
        }
    }
}
</script>
